// This will loop through all products & variants currently displayed in the recommendations widget, check them for safety stock, and remove them if they're below safety stock.
// This is called by configuration in the Rebuy admin portal (the `Ready` event on the cart widget for recommendations).
function filterRebuyRecommendations(widget) {
    if (!widget || !widget.data || !widget.data.products) {
        return;
    }

    // This function returns true if the variant should be ignored for inventory checks.
    function shouldIgnoreInventory(variant) {
        return !variant.inventory_management || variant.inventory_policy != 'deny';
    }

    // Stores the product IDs that should be removed.
    const toRemoveProductIds = [];

    for (let i = 0; i < widget.data.products.length; i++) {
        const product = widget.data.products[i];

        let safetyStockLevel = 0;

        // If this product doesn't have a saftey stock level we can ignore it.
        if (product && product.metafields && product.metafields.custom && product.metafields.custom.safety_stock_level) {
            // Get the saftey stock level
            safetyStockLevel = Number(product.metafields.custom.safety_stock_level);
        }

        // If this product has many variants to choose from, we can filter the variant list.
        if (product.variants && product.variants.length > 1) {
            const variantIdsToRemove = [];

            // Loop through each variant
            for (let variantIndex = 0; variantIndex < product.variants.length; variantIndex++) {
                const variant = product.variants[variantIndex];

                if (shouldIgnoreInventory(variant)) {
                    // We don't need to consider removing this product from recommendations if inventory is not tracked.
                    continue;
                }

                const currentInventory = variant.inventory_quantity;

                let variantSafteyStockLevel = safetyStockLevel;

                // Variants can have a separate metafield for storing saftey stock, so if that exists, use it. If it doesn't, use the product level's.
                if (variant.metafields && variant.metafields.custom && variant.metafields.custom.safety_stock_level) {
                    variantSafteyStockLevel = Number(variant.metafields.custom.safety_stock_level);
                }

                // If the inventory level is below saftey stock
                if (currentInventory < variantSafteyStockLevel) {
                    variantIdsToRemove.push(variant.id);
                }
            }

            // If ALL the variants for this product are out of stock, remove the entire product.
            if (variantIdsToRemove.length == product.variants.length) {
                toRemoveProductIds.push(product.id);
                continue;
            }

            // If only some of the variants for this product are out of stock, remove those variants.
            widget.data.products[i].variants = widget.data.products[i].variants.filter(function (variant) { return !variantIdsToRemove.includes(variant.id); })
        }
        // If this product has only one variant, we can check this variant for saftey stock
        else {
            // Make sure the displayed variant exists.
            // It should always exist, but we're checking for it.
            if (!product.selected_variant) {
                continue;
            }

            if (shouldIgnoreInventory(product.selected_variant)) {
                // We don't need to consider removing this product from recommendations if inventory is not tracked.
                continue;
            }

            const currentInventory = product.selected_variant.inventory_quantity;

            // If the inventory level is below saftey stock
            if (currentInventory < safetyStockLevel) {
                toRemoveProductIds.push(product.id);
            }
        }
    }

    // Remove the out-of-stock products:
    widget.data.products = widget.data.products.filter(function (product) { return !toRemoveProductIds.includes(product.id); });
}